export const AutomationExecutionStatusMap = {
  COMPLETED: { bg: 'bg-green-2', text: 'Success' },
  FAILED: { bg: 'bg-red-2', text: 'Failed' },
  PENDING: { bg: 'bg-yellow-2', text: 'Pending' },
  RUNNING: { bg: 'bg-blue-2', text: 'Running' },
  TERMINATED: { bg: 'bg-gray-2', text: 'Canceled' },
};

export type AutomationExecution = {
  id: string;
  dateTriggered: string;
  dateEnded: string;
  automation: {
    id: string;
    name: string;
  };
  member?: {
    name: string;
    profilePicture: string;
    id: number;
  };
  status: string;
  metadata?: {
    failureReason?: string;
    errorMetadata?: string;
    idempotencyKey?: string;
  };
};

export interface AutomationSummaryProps {
  summary: {
    automations: {
      total: number;
      active: number;
    };
    executions: {
      pastWeek: {
        total: number;
      };
      allTime: {
        total: number;
        failed: number;
      };
    };
  };
  executions: AutomationExecution[];
  isLoading?: boolean;
}
